import Countdown, { zeroPad } from "react-countdown";

import { NumberLabel } from "../shared";

const getWeeklyExpiration = (): Date => {
  const now = Date.now();
  let epochEnd = 1646359199000;

  while (now > epochEnd) {
    epochEnd = epochEnd + 7 * 24 * 60 * 60 * 1000;
  }

  return new Date(epochEnd);
};

const getDailyExpiration = (): Date => {
  const now = Date.now();
  let epochEnd = 1651712400000;

  while (now > epochEnd) {
    epochEnd = epochEnd + 7 * 24 * 60 * 60 * 1000;
  }
  return new Date(epochEnd);
};

export const VaultEpochCountdown: React.FC<{ isCrab?: boolean }> = ({ isCrab }) => (
  <Countdown
    date={isCrab ? getDailyExpiration() : getWeeklyExpiration()}
    renderer={({ days, hours, minutes, seconds }) =>
      (isCrab ? getDailyExpiration().getTime() : getWeeklyExpiration().getTime()) - Date.now() <
      6 * 24 * 60 * 60 * 1000 ? (
        <NumberLabel>
          {days > 0 ? `${days}d ` : null}
          {zeroPad(hours)}h {zeroPad(minutes)}m {zeroPad(seconds)}s
        </NumberLabel>
      ) : (
        <span>Rebalancing</span>
      )
    }
  />
);
